import React from "react";
import {DirectoryItem} from "./DirectoryOutput";

export const ResultOutput = ({result}) => {
    return (<React.Fragment>
        {Object.keys(result).map((key, idx) => {
            return <DirectoryItem key={idx} content={result[key]} title={key}/>;
        })}
    </React.Fragment>);
}